import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { CommonModule } from '@angular/common';
import { CommonService } from '../../services/common-service';
import { EncodeDecodeService } from '../../services/encode-decode-service';
import { FormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastService } from '../../services/toast-service';

@Component({
  selector: 'app-change-password',
  imports: [RouterModule, CommonModule, FormsModule],
  standalone: true,
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})

export class ChangePasswordComponent implements OnInit {
  username: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  error: any = '';
  id: string = '';
  newPassError: any = '';
  isNewPasswordFocused: boolean = false;
  isConfirmPasswordFocused: boolean = false;
  dialogRef: MatDialogRef<ChangePasswordComponent>;

  constructor(
    private commonService: CommonService,
    private toastService: ToastService,
    private router: Router,
    private encodeDecodeService: EncodeDecodeService,
    dialogRef: MatDialogRef<ChangePasswordComponent>
  ) {
    this.dialogRef = dialogRef;
  }

  ngOnInit(): void {
    this.newPassword = '';
    this.confirmPassword = '';
    this.error = '';
    const urlSegments = this.router.url.split('/');
    this.id = urlSegments[urlSegments.length - 1] || '';
  }

  onNewPasswordKeyup() {
    if (this.newPassword) {
      this.isNewPasswordFocused = true;
    }
    if (
      this.newPassword &&
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{12,}$/.test(this.newPassword)
    ) {
      this.newPassError = '';
    } else if (this.newPassword) {
      this.newPassError = "Password does not meet complexity requirements.";
    } else {
      this.newPassError = '';
    }
  }

  onConfirmPasswordKeyup() {
    if (this.confirmPassword) {
      this.isConfirmPasswordFocused = true;
    }
    if (
      this.newPassword &&
      this.confirmPassword &&
      this.newPassword === this.confirmPassword &&
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{12,}$/.test(this.newPassword)
    ) {
      this.error = '';
    } else if (this.confirmPassword) {
      if (this.newPassword !== this.confirmPassword) {
        this.error = "Passwords do not match.";
      } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{12,}$/.test(this.newPassword)) {
        this.error = "Password does not meet complexity requirements.";
      } else {
        this.error = '';
      }
    } else {
      this.error = '';
    }
  }

  updatePassword() {
    // if (!this.username || !this.newPassword || !this.confirmPassword) {
    //   this.toastService.showError("All fields are required.");
    //   return;
    // }

    if (this.newPassword !== this.confirmPassword) {
      this.toastService.showError("Passwords do not match.");
      return;
    }

    let payload: any = {
      newPassword: this.newPassword,
      confirmPassword: this.confirmPassword
    }

    let key: any = sessionStorage.getItem('secretKey')
    const encryptedData = this.encodeDecodeService.encryptionFunction(key, payload);

    this.commonService.callPostAPI(`auth/change-password`, encryptedData).subscribe({
      next: (response: any) => {
        console.log(response);
        this.toastService.showSuccess(response.message);
        this.router.navigate(['/login']);
      },
      error: (error: any) => {
        console.error('Error updating password:', error);
      }
    });
  }


  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;

  toggleNewPasswordVisibility() {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  closeModal() {
    this.dialogRef.close();
  }

  // Remove / add readonly attribute helpers and focus/blur handlers
  private setReadonlyById(id: string, readonly: boolean) {
    const el = document.getElementById(id) as HTMLInputElement | null;
    if (!el) return;
    if (readonly) {
      el.setAttribute('readonly', 'true');
    } else {
      el.removeAttribute('readonly');
    }
  }

  onNewPasswordFocus(event: FocusEvent) {
    this.isNewPasswordFocused = true;
    // remove readonly on focus so mobile/desktop can open the keyboard properly
    const target = event.target as HTMLInputElement | null;
    if (target) {
      target.removeAttribute('readonly');
    } else {
      // fallback by id
      this.setReadonlyById('newPassword', false);
    }
  }

  onNewPasswordBlur(event: FocusEvent) {
    this.isNewPasswordFocused = false;
    // restore readonly only if the field is empty (prevents locking user out)
    const target = event.target as HTMLInputElement | null;
    if (target) {
      if (!this.newPassword) target.setAttribute('readonly', 'true');
    } else {
      if (!this.newPassword) this.setReadonlyById('newPassword', true);
    }
  }

  onConfirmPasswordFocus(event: FocusEvent) {
    this.isConfirmPasswordFocused = true;
    const target = event.target as HTMLInputElement | null;
    if (target) {
      target.removeAttribute('readonly');
    } else {
      this.setReadonlyById('confirmPassword', false);
    }
  }

  onConfirmPasswordBlur(event: FocusEvent) {
    this.isConfirmPasswordFocused = false;
    const target = event.target as HTMLInputElement | null;
    if (target) {
      if (!this.confirmPassword) target.setAttribute('readonly', 'true');
    } else {
      if (!this.confirmPassword) this.setReadonlyById('confirmPassword', true);
    }
  }

}
